const MicrophoneIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00005 9.47501C9.55005 9.47501 10.825 8.20001 10.825 6.65001V3.27501C10.825 1.72501 9.55005 0.450012 8.00005 0.450012C6.45005 0.450012 5.17505 1.72501 5.17505 3.27501V6.65001C5.17505 8.20001 6.45005 9.47501 8.00005 9.47501ZM6.30005 3.27501C6.30005 2.32501 7.07505 1.57501 8.00005 1.57501C8.95005 1.57501 9.70005 2.35001 9.70005 3.27501V6.65001C9.70005 7.60001 8.92505 8.35001 8.00005 8.35001C7.05005 8.35001 6.30005 7.57501 6.30005 6.65001V3.27501Z"
        fill="#9CA3AF"
      />
      <path
        d="M12.7501 6.77502C12.7501 6.47502 12.5001 6.20002 12.1751 6.20002C11.8501 6.20002 11.6001 6.45002 11.6001 6.77502C11.6251 8.75002 10.0001 10.35 8.0001 10.35C6.0001 10.35 4.3751 8.75002 4.3751 6.75002C4.3751 6.45002 4.1251 6.17502 3.8001 6.17502C3.4751 6.17502 3.2251 6.42502 3.2251 6.75002C3.2251 9.15002 5.0501 11.15 7.4001 11.425V15C7.4001 15.3 7.6501 15.575 7.9751 15.575C8.2751 15.575 8.5501 15.325 8.5501 15V11.45C10.9251 11.175 12.7501 9.17502 12.7501 6.77502Z"
        fill="#9CA3AF"
      />
    </svg>
  );
};

export default MicrophoneIcon;
